import { render } from "./skills.vue?vue&type=template&id=e0c48f30&scoped=true"
import script from "./skills.vue?vue&type=script&lang=js"
export * from "./skills.vue?vue&type=script&lang=js"

import "./skills.vue?vue&type=style&index=0&id=e0c48f30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0c48f30"]])

export default __exports__